import { render, staticRenderFns } from "./jourAlert.vue?vue&type=template&id=c0d9cc8e&scoped=true&"
import script from "./jourAlert.vue?vue&type=script&lang=js&"
export * from "./jourAlert.vue?vue&type=script&lang=js&"
import style0 from "./jourAlert.vue?vue&type=style&index=0&id=c0d9cc8e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0d9cc8e",
  null
  
)

export default component.exports